import { SET_FORCE_NOT_FOUND, SET_LAST_ROUTE, SET_ROUTE, SET_ROUTE_COOPERATIVE } from 'reducers/actions-types';
import { baseurl } from 'router/constants';
import * as registry from 'router/registry';
import * as endpoints from 'constants/api-urls';

function getCurrentName() {
    let currentRoute = location.pathname;

    // Append trailing slash if necessary
    if (currentRoute.substr(-1) !== '/') {
        currentRoute += '/';
    }


    return registry.resolve(currentRoute);
}

export default function routeReducer(state = {
    match: {},
    history: {
        ...history,
        replace(url) {
            history.replaceState(null, '', url);
        },
        push(url) {
            history.pushState(null, '', url);
        },
    },
    mustForceNotFound: !!window.__is_not_found__,
    location: window.location,
    cooperative: null,
    config: {},
    meta: {},
    isFirstRoute: true,
    lastRoute: null,
    baseurl: baseurl(),
    endpoints: endpoints,
    registry: registry,
    name: getCurrentName(),
}, { type, route, lastRoute, cooperative, mustForceNotFound }) {
    switch (type) {
        case SET_ROUTE:
            return Object.assign({}, state, {
                isFirstRoute: false,
                name: getCurrentName(),
                ...route,
            });
        case SET_FORCE_NOT_FOUND:
            return Object.assign({}, state, {
                mustForceNotFound,
            });
        case SET_ROUTE_COOPERATIVE:
            return Object.assign({}, state, {
                cooperative,
            });
        case SET_LAST_ROUTE:
            return Object.assign({}, state, {
                lastRoute,
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/router/index.js